<template>
  <div class="news-page">
    <LayoutDefault isShowHeader title="Мероприятия">
      <TheToolbar
        @click-plus="goToEditor(0)"
        @click-trash="deleteNews"
        :selected-row-table="selectedRowTableId"
        buttons
        :isCopy="false"
      />
      <ListTable
        :isActiveFild="false"
        :disablePolitic="false"
        :isSearchShow="false"
        :directionSortable="false"
        :isSortable="false"
        isActiveEventsFild
        directionFilterInHeader
        isActiveFildAll
        directionHeader=""
        headerSecondaryTitle="Заголовок"
        headerTitle=""
        headerFilterInHeader
        :data="dataSource"
        @row-selected="onRowSelect"
        @redirect-to-editor="goToEditor"
        @row-edit="onRowEditSave"
      />
    </LayoutDefault>
  </div>
</template>

<script>
import { onMounted, onBeforeMount, computed, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import TheToolbar from '@/components/blocks/TheToolbar.vue'
// import TheToolbarNew from '@/components/blocks/TheToolbarNew.vue'
import ListTable from '@/components/blocks/ListTable.vue'

import { cutPolicies } from '@/helpers/policiesValidator.js'

export default {
  name: 'NewsView',
  components: {
    LayoutDefault,
    ListTable,
    TheToolbar
  },
  setup () {
    const store = useStore()

    onMounted(() => {
      // запрашиваем данные при монтировании компонента
      // store.dispatch('setNewsDataTable')
    })

    onBeforeMount(() => {
      // запрашиваем данные при монтировании компонента
      store.dispatch('setAllGroupe')
      store.dispatch('setGroupStatuses')
    })

    const policies = computed(() => store.getters.getPolicies)

    // const dataSource = computed(() => {
    //   // данные для отрисовки таблицы
    //   return store.getters.getNewsDataTable
    // })
    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getEventsList
    })

    const selectedRowTableId = ref(0) // id товара по выбранной строке в таблице

    const onRowSelect = (e) => {
      console.log('e: ', e)
      // функция слушает событие выбора строки в таблице
      // получает id товара
      selectedRowTableId.value = e.data.Id
    }

    const goToEditor = (id) => {
      // переход на страницу редактора
      // если передать 0 то пустая форма
      router.push(`/LearningGroupEditingPage/${id}`)
    }

    const deleteNews = () => {
      // инициирует запрос на удаление новости
      store.dispatch('setDeleteItemGroupe', selectedRowTableId.value)
    }

    // const cloneNews = () => {
    //   // инициирует запрос на клонирование товара
    //   store.dispatch('setCloneNews', selectedRowTableId.value)
    // }

    const onRowEditSave = (event) => {
      // при редактировании строки таблицы на предмет публикации
      // и готовности к публикации
      const obj = {
        ReadyToPublishStatus: event.newData.ReadyToPublish,
        PublishedStatus: event.newData.Published,
        Id: event.newData.Id
      }
      store.dispatch('setStatusNewsTable', obj)

      // а это чтобы в таблице сразу менялись данные не дожидаясь выполнения запроса
      const { newData, index } = event
      dataSource.value[index] = newData
    }

    return {
      dataSource,
      policies,
      cutPolicies,
      selectedRowTableId,
      onRowSelect,
      goToEditor,
      deleteNews,
      // cloneNews,
      onRowEditSave
    }
  }
}
</script>

<style>
.headerrow {
  display: none !important;
}
</style>

<style lang="scss" scoped>

</style>
